<div style="margin-top: 5%; padding:10px; text-align: center;">

    <div>
        <img [src]="'/apps/thinkretail/icon.png'" width="200" align="center">
    </div>
    <div style="display:flex; flex-direction:column; align-items: center; ">
        Your Reset Password Link is invalid or has expired
    </div>


</div>